import * as React from 'react';
import S from './CategoryTags.styles';
const CategoryTags = (props) => {
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { variants: props.animation }, props.items.map((item) => (React.createElement(S.Tag, { key: item.id, style: {
            '--bgColour': item.backgroundColor,
            '--fgColour': item.textColor,
        } }, item.name)))));
};
export default CategoryTags;
